import { render, staticRenderFns } from "./CheckoutCustomerForm.vue?vue&type=template&id=b366d7d6&scoped=true"
import script from "./CheckoutCustomerForm.vue?vue&type=script&lang=js"
export * from "./CheckoutCustomerForm.vue?vue&type=script&lang=js"
import style0 from "./CheckoutCustomerForm.vue?vue&type=style&index=0&id=b366d7d6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b366d7d6",
  null
  
)

export default component.exports